import { fetchApi } from '@/lib/utils';

import type { IAccount } from '@enl/type-definitions';

export class AccountsService {
  static urls = {
    getAccounts() {
      return `/v1/auth/accounts`;
    },
  };

  static getAccounts() {
    return fetchApi<IAccount[]>(this.urls.getAccounts());
  }
}
